<template>
  <ListItem
    :to="{
      name: 'vehicleTypeCarsList',
      params: { id: vehicleType.id },
    }"
    :drop-down-items="
      !hideDropdownDotted
        ? [
            {
              title: t('editVehicleType'),
              onClick: () =>
                $router.push({
                  name: 'editVehicleType',
                  params: { id: vehicleType.id },
                }),
            },
          ]
        : undefined
    "
  >
    <figure class="relative basis-1/4 md:basis-[14%]">
      <img :src="vehicleType.imageUrl" />
      <div
        class="absolute -right-1 -top-1 flex size-6 items-center justify-center rounded-full bg-bittersweet-600 pr-[1px] pt-0.5 text-white md:right-1 md:top-0"
      >
        {{ vehicleType.numCars ?? 0 }}
      </div>
    </figure>

    <div class="grid basis-3/4 md:flex md:basis-[86%] md:gap-4">
      <div class="flex basis-[50%] flex-col">
        <p>{{ vehicleType.make.name }} {{ vehicleType.model }}</p>
      </div>
      <div class="flex basis-[50%] flex-col">
        <p>{{ t(`categories.${vehicleType.mainCategory}`) ?? 'n.a.' }}</p>
      </div>
    </div>
  </ListItem>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
import type { VehicleType } from '@/entities/vehicle-type.entity.ts';
import ListItem from '@/components/ListItem.vue';

defineProps<{
  vehicleType: VehicleType;
  hideDropdownDotted?: boolean;
}>();

const { t } = useI18n();
</script>

<i18n lang="json">
{
  "en": {
    "vehicleType": "Vehicle Type",
    "category": "Category",
    "number": "Number",
    "editVehicleType": "Edit Vehicle Type",
    "hasXCars": "Has {count} car | Has {count} cars"
  },
  "de": {
    "vehicleType": "Vehicle Type",
    "category": "Kategorie",
    "number": "Anzahl",
    "editVehicleType": "Vehicle Type bearbeiten",
    "hasXCars": "Hat {count} Auto | Hat {count} Autos"
  },
  "es": {
    "vehicleType": "Tipo de vehículo",
    "category": "Categoría",
    "number": "Cantidad",
    "editVehicleType": "Editar tipo de vehículo",
    "hasXCars": "Tiene {count} vehículo | Tiene {count} vehículos"
  }
}
</i18n>
